var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "rangescale_edit",
    },
    [
      _c(
        "div",
        {
          ref: "autofocus",
          staticClass: "formpart",
          attrs: {
            tabindex: "0",
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$gettext("Einleitungstext")) +
              "\n        "
          ),
          _c("StudipWysiwyg", {
            model: {
              value: _vm.val_clone.description,
              callback: function callback($$v) {
                _vm.$set(_vm.val_clone, "description", $$v)
              },
              expression: "val_clone.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("InputArray", {
        attrs: {
          label: _vm.$gettext("Aussage"),
          "label-plural": _vm.$gettext("Aussagen"),
          "additional-colspan": _vm.options.length,
        },
        scopedSlots: _vm._u([
          {
            key: "header-cells",
            fn: function fn() {
              return _vm._l(_vm.options, function (option, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    staticClass: "option-cell",
                  },
                  [
                    _vm._v(
                      "\n                 " + _vm._s(option) + "\n             "
                    ),
                  ]
                )
              })
            },
            proxy: true,
          },
          {
            key: "body-cells",
            fn: function fn() {
              return _vm._l(_vm.options, function (option, index) {
                return _c(
                  "td",
                  {
                    key: index,
                    staticClass: "option-cell",
                  },
                  [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        disabled: "",
                        title: option,
                      },
                    }),
                  ]
                )
              })
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.val_clone.statements,
          callback: function callback($$v) {
            _vm.$set(_vm.val_clone, "statements", $$v)
          },
          expression: "val_clone.statements",
        },
      }),
      _vm._v(" "),
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.val_clone.mandatory,
              expression: "val_clone.mandatory",
              modifiers: {
                number: true,
              },
            },
          ],
          attrs: {
            type: "checkbox",
            "true-value": "1",
            "false-value": "0",
          },
          domProps: {
            checked: Array.isArray(_vm.val_clone.mandatory)
              ? _vm._i(_vm.val_clone.mandatory, null) > -1
              : _vm._q(_vm.val_clone.mandatory, "1"),
          },
          on: {
            change: function change($event) {
              var $$a = _vm.val_clone.mandatory,
                $$el = $event.target,
                $$c = $$el.checked ? "1" : "0"
              if (Array.isArray($$a)) {
                var $$v = _vm._n(null),
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(_vm.val_clone, "mandatory", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.val_clone,
                      "mandatory",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.val_clone, "mandatory", $$c)
              }
            },
          },
        }),
        _vm._v("\n        " + _vm._s(_vm.$gettext("Pflichtfrage")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.val_clone.randomize,
              expression: "val_clone.randomize",
              modifiers: {
                number: true,
              },
            },
          ],
          attrs: {
            type: "checkbox",
            "true-value": "1",
            "false-value": "0",
          },
          domProps: {
            checked: Array.isArray(_vm.val_clone.randomize)
              ? _vm._i(_vm.val_clone.randomize, null) > -1
              : _vm._q(_vm.val_clone.randomize, "1"),
          },
          on: {
            change: function change($event) {
              var $$a = _vm.val_clone.randomize,
                $$el = $event.target,
                $$c = $$el.checked ? "1" : "0"
              if (Array.isArray($$a)) {
                var $$v = _vm._n(null),
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(_vm.val_clone, "randomize", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.val_clone,
                      "randomize",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.val_clone, "randomize", $$c)
              }
            },
          },
        }),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$gettext("Antworten den Teilnehmenden zufällig präsentieren")
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Maximum")) + "\n        "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.val_clone.maximum,
              expression: "val_clone.maximum",
              modifiers: {
                number: true,
              },
            },
          ],
          attrs: {
            type: "number",
            min: _vm.val_clone.minimum,
          },
          domProps: {
            value: _vm.val_clone.maximum,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.val_clone, "maximum", _vm._n($event.target.value))
            },
            blur: function blur($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Minimum")) + "\n        "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.val_clone.minimum,
              expression: "val_clone.minimum",
              modifiers: {
                number: true,
              },
            },
          ],
          attrs: {
            type: "number",
            min: "1",
            max: _vm.val_clone.maximum,
          },
          domProps: {
            value: _vm.val_clone.minimum,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.val_clone, "minimum", _vm._n($event.target.value))
            },
            blur: function blur($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$gettext("Ausweichantwort (leer lassen für keine)")) +
            "\n        "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.val_clone.alternative_answer,
              expression: "val_clone.alternative_answer",
              modifiers: {
                trim: true,
              },
            },
          ],
          attrs: {
            type: "text",
          },
          domProps: {
            value: _vm.val_clone.alternative_answer,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.val_clone,
                "alternative_answer",
                $event.target.value.trim()
              )
            },
            blur: function blur($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }